module.exports = __webpack_public_path__ + "img/用电服务平台.ead27c00.png";